import apiClient from './apiClient';

export interface QueryParams {
  docFrom?: string;
  docTo?: string;
  unprintedOnly?: boolean;
}

export interface NotificationRow {
  doc_no: string;
  emp_name: string;
  doc_desc: string;
  effect_date: string;
  dept_code: string;
  dept_name: string;
  title_code: string;
  title_name: string;
  print_date: string;
  emp_count: number;
}

export interface QueryResponse {
  data: NotificationRow[];
  count: number;
  message?: string;
}

export const pw9304Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9304/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw9304/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
